import React from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">

          {/* BRAND / LOGO */}
          <div className="col-lg-4 col-md-6 mb-4">
            <div className="footer-brand">
              <div className="F-Logo d-flex">
                <img
                  src="/images/img/Logo.png"
                  alt="Goodweel Crop Care Logo"
                  className="footer-logo-img"
                />
                <h3 className="footer-logo">Goodweel</h3>
              </div>

              <p>
                Goodweel Crop Care is a trusted agrochemical manufacturing
                company committed to strengthening Indian agriculture
                through eco-friendly, high-quality, and farmer-focused
                crop protection solutions.
              </p>

              <a href="/contact" className="footer-btn">
                Contact Us
              </a>
            </div>
            {/* SOCIAL */}
            <div className="footer-social">
              <a href="https://www.facebook.com/share/1AaUs4Ypji/" aria-label="Facebook">
                <FaFacebookF />
              </a>
              <a href="https://www.instagram.com/Goodweelcropcare" aria-label="Instagram">
                <FaInstagram />
              </a>
              <a href="https://www.youtube.com/@GoodweelCropCare" aria-label="Youtube">
                <FaYoutube />
              </a>
            </div>
          </div>

          {/* QUICK LINKS */}
          <div className="col-lg-2 col-md-6 mb-4">
            <h5 className="footer-title">Quick Links</h5>
            <ul className="footer-links">
              <li><a href="/">Home</a></li>
              <li><a href="/about">About Us</a></li>
              <li><a href="/products">Products</a></li>
              <li><a href="/Productdetail">Products Details</a></li>
              {/* <li><a href="/distributor-enquiry">Distributor</a></li> */}
              <li><a href="/contact">Contact</a></li>
            </ul>
          </div>

          {/* CATEGORIES */}
          <div className="col-lg-3 col-md-6 mb-4">
            <h5 className="footer-title">Product Categories</h5>
            <ul className="footer-links">
              <li><a href="/products/insecticides">Insecticides</a></li>
              <li><a href="/products/fungicide">Fungicides</a></li>
              <li><a href="/products/herbicide">Herbicides</a></li>
              <li><a href="/products/fertilizer">Fertilizers</a></li>
              <li><a href="/products/pgr">Plant Growth Regulators</a></li>
              <li><a href="/products/npk">NPK Fertilizers</a></li>
            </ul>
          </div>

          {/* CONTACT */}
          <div className="col-lg-3 col-md-6 mb-4">
            <h5 className="footer-title">Contact Details</h5>

            <div className="footer-contact">
              <p>
                <strong>Email:</strong><br />
                <a href="mailto:Goodweelcropcare@gmail.com">
                  Goodweelcropcare@gmail.com
                </a>
              </p>

              <p>
                <strong>Phone:</strong><br />
                <a href="tel:+918815529978">
                  +91 88155 29978
                </a>
              </p>

              <p>
                <strong>Location:</strong><br />
                <a
                  href="https://maps.app.goo.gl/wUWw86a1dye9YdjN8"
                  target="_blank"
                  rel="noreferrer"
                >
                  Ratlam, Madhya Pradesh – 457001, India
                </a>
              </p>
            </div>
          </div>

        </div>

        {/* BOTTOM BAR */}
        <div className="footer-bottom">
          <p>
            © {new Date().getFullYear()}
            <a href="https://taaksoftech.com" target="_blank" rel="noreferrer" className="footer-credit">
              {" "}Goodweel Crop Care.{" "}
            </a>
            a All Rights Reserved.
          </p>
          <p>Made by{" "}
            <a href="https://taaksoftech.com" target="_blank" rel="noreferrer" className="footer-credit">
              Taak Softech Pvt. Ltd.
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
